import { render, staticRenderFns } from "./action.vue?vue&type=template&id=2fe54632&"
import script from "./action.vue?vue&type=script&lang=ts&"
export * from "./action.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe54632')) {
      api.createRecord('2fe54632', component.options)
    } else {
      api.reload('2fe54632', component.options)
    }
    module.hot.accept("./action.vue?vue&type=template&id=2fe54632&", function () {
      api.rerender('2fe54632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/action-bar/action.vue"
export default component.exports